import { render } from "./ReturnAndRefundReasonComponent.vue?vue&type=template&id=370ad84c"
import script from "./ReturnAndRefundReasonComponent.vue?vue&type=script&lang=js"
export * from "./ReturnAndRefundReasonComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/returnAndRefunds/ReturnAndRefundReasonComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "370ad84c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('370ad84c', __exports__)) {
    api.reload('370ad84c', __exports__)
  }
  
  module.hot.accept("./ReturnAndRefundReasonComponent.vue?vue&type=template&id=370ad84c", () => {
    api.rerender('370ad84c', render)
  })

}


export default __exports__